import { mainApi } from '../index';

export interface ApplyOfferPayload {
    cancel_reason?: string;
    cancel_reason_detail?: string;
    cancel_description?: string;
}

/**
 * Apply one month free offer to subscription
 */
export async function applyFreeMonthOffer(payload: ApplyOfferPayload): Promise<void> {
    await mainApi.post('/v1/users/subscriptions/one-month-free', payload);
}

/**
 * Apply two months 50% discount offer to subscription
 */
export async function applyTwoMonthDiscountOffer(payload: ApplyOfferPayload): Promise<void> {
    await mainApi.post('/v1/users/subscriptions/two-month-discount', payload);
}

/**
 * Cancel platform subscription (invalidate)
 */
export async function cancelPlatformSubscription(subscriptionId: string): Promise<void> {
    await mainApi.post('/v1/users/subscriptions/invalidate', {
        stripe_id: subscriptionId,
    });
}
